import { render, staticRenderFns } from "./RewardsHistory.vue?vue&type=template&id=1673f21e&scoped=true"
import script from "./RewardsHistory.vue?vue&type=script&lang=js"
export * from "./RewardsHistory.vue?vue&type=script&lang=js"
import style0 from "./RewardsHistory.vue?vue&type=style&index=0&id=1673f21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1673f21e",
  null
  
)

export default component.exports